module.exports = __webpack_public_path__ + "img/dink-bedroom-1.3a7bdcc6.jpeg";